import { useEffect, useState } from "react";
import { loadCms } from "./loadCms";

/**
 * Site-wide SEO metadata — Organization + WebSite JSON-LD assembled
 * server-side from CMS SiteSettings by `/api/seo/site-metadata`.
 *
 * Single source of truth. All Organization / sameAs / contactPoint /
 * postal address data lives in Payload's SiteSettings global — this
 * hook merely fetches the composed JSON-LD objects. Never returns
 * hardcoded strings.
 */
const FALLBACK = {
  baseURL: typeof window !== "undefined" ? window.location.origin : "",
  companyName: "Manufacturing and Trading Services",
  displayName: "Manufacturing & Trading Services",
  shortName: "MTS",
  logoUrl: null,
  sameAs: [],
  email: null,
  organizationSchema: null,
  websiteSchema: null,
};

export function useSeoMetadata() {
  const [state, setState] = useState({ data: FALLBACK, loading: true, error: null, source: "fallback" });

  useEffect(() => {
    return loadCms(
      "/api/seo/site-metadata",
      "mts:seo-metadata:v2",
      FALLBACK,
      setState
    );
  }, []);

  return state;
}
